import React from "react";
import { useTranslation } from "react-i18next";

/** Validation message under a form field. `message` is an i18n key (e.g. "validation.required"). */
export function FieldError({ message, id }: { message?: string | null; id?: string }) {
	const { t } = useTranslation();
	if (!message) return null;
	return (
		<p id={id} role="alert" className="mt-1 text-xs text-destructive">
			{t(message)}
		</p>
	);
}

/**
 * First message per field from a zod `safeParse` failure: `{ items: "validation.itemsRequired", … }`.
 * Nested item errors are reported once under `items`.
 */
export function firstFieldErrors(issues: { path: (string | number)[]; message: string }[]): Record<string, string> {
	const out: Record<string, string> = {};
	for (const issue of issues) {
		const field = String(issue.path[0] ?? "form");
		if (!out[field]) out[field] = issue.message;
	}
	return out;
}
